import   React  from "react";



const SettingManager: React.FC = () => {


  return (
    <>
    </>
  );
};

export default SettingManager;
